import VueCookie from 'vue-cookies'
 
const tokenname = 'tk_login'
 
export function getTokenInCookie() {
  return VueCookie.get(tokenname);
}
 
export function setTokenInCookie(data) {
  return VueCookie.set(tokenname,data)
}
 
export function removeTokenInCookie() {
  return VueCookie.remove(tokenname)
}



// WEBPACK FOOTER //
// ./src/utils/index.js